// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"119cce00","453":"1407b060","528":"131276b1","823":"990165a9","871":"eafa49c8"}[chunkId] + ".chunk.js";
};